/** Overlay à afficher */
enum OverlayEnum {
	SingleNodeSelection = 0,
	Loading = 1,
	Saving = 2
}

export default OverlayEnum;